import {all, call, fork, put, takeEvery, delay} from 'bukku/shared/SagaService';
import actions from './actions';
// import { message } from 'antd';
import {get, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

import { getDummyFinancingData, useDummyFinancingData} from "../../containers/AppPage/Financing/utils/dummy";
import dayjs from 'dayjs';

const successKeys = [
    actions.FINANCING_SETTINGS_UPDATE_SUCCESS,
];
const errorKeys = [
    actions.FINANCING_SETTINGS_UPDATE_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.FINANCING_SETTINGS_UPDATE_SUCCESS:
            return t`The settings are updated.`;
        default:
            return null;
    }
};

// Read FORM_DESIGN list
function* readFinancingDashboardRequest() {
    yield takeEvery(actions.FINANCING_DASHBOARD_READ_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            function* () {
                if (useDummyFinancingData) {
                    yield delay(1);
                    // OK
                    yield put({
                        type: actions.FINANCING_DASHBOARD_READ_SUCCESS,
                        data: getDummyFinancingData(),
                    });
                }
                else {
                    const response = yield call(get, '/financing/dashboard');
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FINANCING_DASHBOARD_READ_SUCCESS,
                        data, // <--USE THIS
                        // data: getDummyFinancingData(),
                    });
                }
            });
    });
}

function* updateFinancingSettingRequest() {
    yield takeEvery(actions.FINANCING_SETTINGS_UPDATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                if (useDummyFinancingData) {
                    yield delay(1500);

                    // OK
                    yield put({
                        type: actions.FINANCING_SETTINGS_UPDATE_SUCCESS,
                        consent_level: request.consent_level,
                        consented_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                        msic_code: request.msic_code,
                    });
                }
                else {
                    const response = yield call(puto, `/financing/settings`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.FINANCING_SETTINGS_UPDATE_SUCCESS,
                        // consent_level: 1,
                        // consented_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                        // msic_code: "062",
                        consent_level: data.consent_level,
                        consented_at: data.consented_at,
                        msic_code: data.msic_code,
                    });
                }
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(updateFinancingSettingRequest),
        fork(readFinancingDashboardRequest),
    ]);
}
